export default __webpack_public_path__ + "static/media/learn-more-abstraction.7c7d9de8.png";